import { StaticImage } from 'gatsby-plugin-image';
import * as React from 'react';
import { enterCheck } from './Constants';
import FailX from './FailX';

const SearchBox = ({
	clear,
	numberOfGuessesOrStatic,
	query,
	response,
	setResponse,
	submitAnswer,
	useStaticQuery,
	wrong,
	giveUp,
	tester,
}: {
	numberOfGuessesOrStatic: number;
	query: string;
	response: string;
	submitAnswer: (arg1?: string) => void;
	useStaticQuery?: string;
	wrong: number;
	giveUp: boolean;
	tester?: boolean;
	setResponse: (arg0: string) => void;
	clear: () => void;
}) => (
	<div
		style={{
			display: 'flex',
			height: '40px',
			lineHeight: '40px',
			marginLeft: 'var(--single)',
			marginTop: 'var(--half)',
			position: 'relative',
		}}>
		<FailX giveUp={giveUp} useStaticQuery={useStaticQuery} wrong={wrong} />
		<StaticImage
			alt="Submit"
			className="hideOnMobile"
			imgStyle={{ display: 'inline-block', width: '20px' }}
			loading="eager"
			objectFit="scale-down"
			placeholder="blurred"
			src="../../images/search.svg"
			style={{ marginRight: 'var(--half)' }}
		/>
		<div id="query" style={{ marginRight: '0.25em', whiteSpace: 'nowrap' }}>
			{query}
		</div>
		<input
			autoFocus
			disabled={wrong === numberOfGuessesOrStatic}
			id="mainInput"
			maxLength={40}
			onChange={(event) => setResponse(event.target.value)}
			onKeyDown={(event) => enterCheck(event) && submitAnswer()}
			spellCheck="true"
			style={{
				color: 'inherit !important',
				fontWeight: tester ? 'normal' : 'bold',
				overflow: 'hidden',
			}}
			type="text"
			value={response}
		/>
		<div style={{ display: 'flex', margin: '0 15px', width: '30px' }}>
			{response.length > 0 && (
				<button
					onClick={clear}
					style={{ background: 'none', border: '0', display: 'flex' }}
					type="reset">
					<StaticImage
						alt="Clear"
						imgStyle={{
							cursor: 'pointer',
							display: 'inline-block',
						}}
						loading="eager"
						objectFit="scale-down"
						onKeyDown={(event) => event.key === 'Enter' && setResponse('')}
						placeholder="blurred"
						src="../../images/x.svg"
						style={{
							display: 'inline-block',
							width: '30px',
						}}
					/>
				</button>
			)}
		</div>
	</div>
);
export default SearchBox;
